import script from "./NativeCloudPhonePlayer.vue?vue&type=script&setup=true&lang=js"
export * from "./NativeCloudPhonePlayer.vue?vue&type=script&setup=true&lang=js"

import "./NativeCloudPhonePlayer.vue?vue&type=style&index=0&id=3d9e783a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d9e783a"]])

export default __exports__